const isParentNavEnabled = false;

export default [
    {
        path: "med-app-req",
        name: "med-app-req",
        redirect: "Request",
    },
    {
        path: "Request",
        name: "Request",
        component: () =>
            import(/* webpackChunkName: "med-app-req-Request" */ "../views/Request.vue"),
        meta: {
            mainNavEnabled: isParentNavEnabled,
        },
    },
];
